//#region src/schema/localization/locales/ar.ts
var e = {
	schema: {
		noAllowedValues: "لا توجد قيم تستوفي قيد التعداد هذا.",
		example: "مثال",
		examples: "أمثلة",
		default: "الافتراضي",
		schema: "المخطط",
		emptyObject: "كائن فارغ",
		showAdditionalProperties: "إظهار الخصائص الإضافية",
		showOneMoreProperty: "إظهار خاصية إضافية واحدة",
		showMoreProperties: "إظهار المزيد من الخصائص ({count})",
		forName: "لـ {name}",
		showSchemaDetails: "إظهار تفاصيل المخطط",
		oneOf: "واحد من",
		anyOf: "أي من",
		allOf: "كل من",
		not: "ليس",
		unknownType: "نوع غير معروف",
		propertyCount: "الخصائص: {count}",
		headerCount: "الترويسات: {count}",
		recursiveReference: "مرجع تكراري إلى {name}",
		recursive: "تكراري",
		additionalProperties: "خصائص إضافية",
		const: "ثابت",
		deprecated: "مهمل",
		discriminator: "المميّز",
		enum: "تعداد",
		format: "التنسيق",
		greaterThan: "أكبر من",
		keys: "المفاتيح",
		lessThan: "أقل من",
		max: "الحد الأقصى",
		min: "الحد الأدنى",
		maxLength: "أقصى طول",
		minLength: "أدنى طول",
		multipleOf: "مضاعف لـ",
		nullable: "يقبل null",
		propertyNames: "أسماء الخصائص",
		pattern: "النمط",
		copyPattern: "نسخ النمط",
		readOnly: "قراءة فقط",
		required: "مطلوب",
		hideValues: "إخفاء القيم",
		showAllValues: "عرض كل القيم",
		type: "النوع",
		unique: "فريد",
		values: "القيم",
		writeOnly: "كتابة فقط"
	},
	common: {
		copyDefault: "نسخ القيمة الافتراضية",
		copyExample: "نسخ القيمة النموذجية"
	},
	actions: { copyLinkTo: "نسخ الرابط إلى {name}" }
};
//#endregion
export { e as ar };

//# sourceMappingURL=ar.js.map